import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ConnectionStatusIndicator = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'match',
      message: 'New cosmic match with Luna_Mystic',
      time: '2m ago',
      unread: true
    },
    {
      id: 2,
      type: 'friend_request',
      message: 'StarSeeker wants to connect',
      time: '5m ago',
      unread: true
    },
    {
      id: 3,
      type: 'compatibility',
      message: 'High compatibility detected nearby',
      time: '10m ago',
      unread: false
    }
  ]);

  const [isOnline, setIsOnline] = useState(true);
  const [activeConnections, setActiveConnections] = useState(3);
  const [isExpanded, setIsExpanded] = useState(false);

  const unreadCount = notifications.filter(n => n.unread).length;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'match':
        return 'Heart';
      case 'friend_request':
        return 'UserPlus';
      case 'compatibility':
        return 'Sparkles';
      default:
        return 'Bell';
    }
  };

  const handleNotificationClick = (notificationId) => {
    setNotifications(prev => 
      prev.map(n => 
        n.id === notificationId ? { ...n, unread: false } : n
      )
    );
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="relative">
      {/* Status Indicator Button */}
      <Button
        variant="ghost"
        onClick={toggleExpanded}
        className="relative p-2"
      >
        <div className="flex items-center space-x-2">
          <div className="relative">
            <Icon name="Users" size={20} color="currentColor" />
            {/* Online Status Dot */}
            <div className={`absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-background ${
              isOnline ? 'bg-success animate-gentle-pulse' : 'bg-text-secondary'
            }`}></div>
            {/* Notification Badge */}
            {unreadCount > 0 && (
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-error text-error-foreground text-xs font-bold rounded-full flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </div>
            )}
          </div>
          <span className="hidden lg:inline text-sm">
            {activeConnections} active
          </span>
        </div>
      </Button>

      {/* Expanded Dropdown */}
      {isExpanded && (
        <div className="absolute top-full right-0 mt-2 w-80 glass bg-surface/95 backdrop-blur-cosmic rounded-lg shadow-elevation-4 border border-border z-dropdown">
          {/* Header */}
          <div className="px-4 py-3 border-b border-border/50">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-heading font-medium text-text-primary">
                Connections
              </h3>
              <div className="flex items-center space-x-2 text-xs text-text-secondary">
                <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-success' : 'bg-text-secondary'}`}></div>
                <span>{isOnline ? 'Online' : 'Offline'}</span>
              </div>
            </div>
          </div>

          {/* Active Connections Summary */}
          <div className="px-4 py-3 border-b border-border/50">
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-lg font-heading font-semibold text-primary">
                  {activeConnections}
                </div>
                <div className="text-xs text-text-secondary">Active</div>
              </div>
              <div>
                <div className="text-lg font-heading font-semibold text-secondary">
                  12
                </div>
                <div className="text-xs text-text-secondary">Matches</div>
              </div>
              <div>
                <div className="text-lg font-heading font-semibold text-accent">
                  87%
                </div>
                <div className="text-xs text-text-secondary">Compatibility</div>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="max-h-64 overflow-y-auto">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                onClick={() => handleNotificationClick(notification.id)}
                className={`px-4 py-3 border-b border-border/30 cursor-pointer transition-cosmic hover:bg-surface/50 ${
                  notification.unread ? 'bg-primary/5' : ''
                }`}
              >
                <div className="flex items-start space-x-3">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    notification.type === 'match' ? 'bg-error/20' :
                    notification.type === 'friend_request'? 'bg-primary/20' : 'bg-accent/20'
                  }`}>
                    <Icon 
                      name={getNotificationIcon(notification.type)} 
                      size={16} 
                      color={
                        notification.type === 'match' ? '#EF4444' :
                        notification.type === 'friend_request'? '#4A5FBF' : '#F59E0B'
                      }
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-text-primary">
                      {notification.message}
                    </p>
                    <p className="text-xs text-text-secondary font-mono mt-1">
                      {notification.time}
                    </p>
                  </div>
                  {notification.unread && (
                    <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Footer Actions */}
          <div className="px-4 py-3 border-t border-border/50">
            <div className="flex space-x-2">
              <Button variant="primary" fullWidth onClick={() => console.log('View all')}>
                View All Connections
              </Button>
              <Button variant="ghost" iconName="Settings" onClick={() => console.log('Settings')}>
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isExpanded && (
        <div 
          className="fixed inset-0 z-dropdown-backdrop" 
          onClick={() => setIsExpanded(false)}
        ></div>
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;